import styled from "styled-components";
import { bodyStyle, type TextStyleType } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Title = styled.h2<TextStyleType>`
    ${bodyStyle};
    text-transform: none;
`;

export const List = styled.ul`
    display: block;
    margin: ${theme.space[1]}px 0 ${theme.space[2]}px;
    padding: 0;

    li {
        display: list-item;
        position: relative;
        padding-inline-start: 12px;
        margin-bottom: ${theme.space[1]}px;
        list-style-type: none;

        &,
        &:not(:empty) {
            font-size: 1.3rem;
            line-height: 2rem;
            color: ${theme.colors.grey4};
        }

        &::before {
            display: block;
            position: absolute;
            top: 50%;
            width: 3px;
            height: 3px;
            inset-inline-start: 0;
            font-size: 3rem;
            line-height: 2rem;
            content: " ";
            background-color: ${theme.colors.primaryRed};
            border-radius: 50%;
            transform: translateY(-50%);
        }
    }
`;
